// eslint-disable-next-line import/prefer-default-export
export const linkHasTracking = link => {
  const {
    event,
    category,
    action,
    label,
  } = (link && link.gtm) || {};
  return !!(event || category || action || label);
};
